import request from '@/utils/request'
const HOST = 'https://myoa.mmzqoa.net'

//根据系统用户ID映射目标系统用户ID
export function getSourceUserId(id) {
  return request({
    url: `/docexechange/gen-user/v1/deptmapperset/${id}`,
    method: 'get'
  })
}

// 会务系统-收阅报名
export function getReceiveRegistraList(params) {
  return request({
    url: HOST + '/pages/MoaZjmGw/getReceiveRegistraList.do',
    method: 'get',
    params: {
      ...params,
      type: 1,
      pageNo: params.pageNo || params.page || 1,
      pageSize: params.pageSize || params.size || 10
    },
    decrypt: true
  }).then(res => {
    console.log(res)
    return res
  })
}

// 会务系统-数量统计
export function getHwtzMsgCount(params) {
  return request({
    url: HOST + '/pages/MoaZjmGw/getHwtzMsgCount.do',
    method: 'get',
    params,
    decrypt: true
  }).then(res => {
    console.log(res)
    return res
  })
}

export async function getListAndCount(params) {
  const { data: count } = await getHwtzMsgCount(params)
  const res = await getReceiveRegistraList(params)
  return {
    ...res,
    count
  }
}